<template>
<ItpPanel
  :collapsible="b_7315092382398562_collapsible"
>
  <template
    slot="caption"
  >
    <h5
      class="ml-3 mb-3"
    >
      <span>
        Child jobs
      </span>
      <ItpBadge
        :text="'(' + (parent.jobs && parent.jobs.length || 0) + ')'"
        variant="light"
      >
      </ItpBadge>
    </h5>
  </template>
  <ul
    class="list-group"
  >
    <ItpPanel
      :key="item.id"
      collapsible
      initialState="collapsed"
      class="list-group-item"
      v-for="item in parent.jobs"
    >
      <template
        slot="caption"
      >
        <JobHeader
          :item="item"
        >
        </JobHeader>
      </template>
      <JobView
        no-display-header
        :item="item"
        class="mt-3"
      >
      </JobView>
    </ItpPanel>
  </ul>
</ItpPanel>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ChildJobs extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  parent!: object;

  @Watch('parent')
  onParent(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parent")
  }

  ux!: any;
  b_7315092382398562_collapsible!: any;
  dataMembers = ['ux', 'b_7315092382398562_collapsible'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
        b_7315092382398562_collapsible: false,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("ChildJobs", ChildJobs);

</script>